import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { mergeMap, tap } from "rxjs/operators";
import { CommentApi } from "../api-services/comment-api/comment-api.models";
import { Comment } from "../models/comment";

@Injectable()
export class CommentService {
  private comments: Comment[] = [];

  constructor(private commentApiService: CommentApi) {}

  private findCommentNameByCode(code: string): string {
    const comment: Comment = this.comments.find(
      (comment) => comment.code === code,
    );
    return comment ? comment.code : "";
  }

  private findCommentsByStatusCode(statusCode: string): Comment[] {
    return this.comments.filter((comment) => comment.statusCode === statusCode);
  }

  public getPredefinedTextByCode(code: string): Observable<string> {
    if (this.comments.length) {
      return observableOf(this.findCommentNameByCode(code));
    } else {
      return this.getAllComments().pipe(
        mergeMap((val) => observableOf(this.findCommentNameByCode(code))),
      );
    }
  }

  public getAlreadyFetchedPredefinedTextByCode(code: string): string {
    if (!this.comments?.length) {
      throw Error(
        `Tentative d'extraction de commentaire prédéfini n'ayant pas été obtenu au préalable. Veuillez contacter le support informatique.`,
      );
    }

    return this.findCommentNameByCode(code);
  }

  public getPredefinedTextByStatusCode(
    statusCode: string,
  ): Observable<Comment[]> {
    if (this.comments.length) {
      return observableOf(this.findCommentsByStatusCode(statusCode));
    } else {
      return this.getAllComments().pipe(
        mergeMap((val) =>
          observableOf(this.findCommentsByStatusCode(statusCode)),
        ),
      );
    }
  }

  public getAllComments(): Observable<Comment[]> {
    return this.comments.length
      ? observableOf(this.comments)
      : this.commentApiService
          .getPredefinedComments()
          .pipe(
            tap(
              (comments) =>
                (this.comments = comments.filter((comment) => comment.name)),
            ),
          );
  }
}
